import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import ErrorMessage from '@/components/common/ErrorMessage';
import CardLayout from '@/components/Layout/CardLayout';
import FieldLayout from '@/components/Layout/FieldLayout';
import Button from '@/components/ui/Button';
import Label from '@/components/ui/Label';
import SearchSelectBox, {
  ISelectOption,
} from '@/components/ui/SearchSelectBox';
import {
  IAddAssetRequestForm,
  IAssetCategoryResponse,
} from '@/interfaces/assets.model';
import { IDeleteResponse } from '@/interfaces/common.model';
import { showToastNotification } from '@/utility/helper';
import { errorTypes } from '@/utility/validation';
import { useEffect, useState } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { Modal } from 'reactstrap';
interface IAddAssetRequestModalProps {
  isOpen: boolean;
  editData: IAddAssetRequestForm | null;
  onClose: () => void;
  getRequests?: () => void;
}
const AddAssetRequestModal = ({
  isOpen,
  editData,
  onClose,
  getRequests,
}: IAddAssetRequestModalProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    clearErrors,
    reset,
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<IAddAssetRequestForm>({
    defaultValues: editData || undefined,
  });

  useEffect(() => {
    if (editData) {
      reset({
        assetCategoryId: editData.assetCategoryId,
        description: editData.description,
      });
    } else {
      reset({
        assetCategoryId: '',
        description: '',
      });
    }
  }, [editData, reset]);
  const onSubmit: SubmitHandler<IAddAssetRequestForm> = async (data) => {
    console.log(data);
    try {
      setIsLoading(true);
      const API = editData
        ? API_URL +
          API_ENDPOINT.updateAssetRequest +
          '?assetRequestId=' +
          editData.id
        : API_URL + API_ENDPOINT.addAssetRequest;

      const response: IDeleteResponse = await callApi(API, {
        method: 'POST',
        data: {
          ...data,
          ...(editData && { assetRequestId: editData.id }),
        },
      });
      if (response?.status) {
        showToastNotification('success', response?.message);
        if (getRequests) getRequests();
        onClose();
        reset();
      }
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };
  const getAssetsCategory = async (
    inputValue?: string,
  ): Promise<ISelectOption[]> => {
    try {
      const API = `${API_URL}${API_ENDPOINT?.getAssetsCategory}?search=${inputValue}`;
      const response: IAssetCategoryResponse = await callApi(API, {
        method: 'GET',
      });
      if (response.status) {
        return response.data?.assetCategory.map((dep) => ({
          value: dep.id,
          label: dep.name,
        }));
      }
      return [];
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
      return [];
    }
  };
  // const getAssets = async (inputValue?: string): Promise<ISelectOption[]> => {
  //   try {
  //     const API = `${API_URL}${API_ENDPOINT?.assetList}?search=${inputValue}`;
  //     const response: IAssetResponse = await callApi(API, {
  //       method: 'GET',
  //     });
  //     if (response.status) {
  //       return response.data?.asset.map((dep) => ({
  //         value: dep.id,
  //         label: dep.name,
  //       }));
  //     }
  //     return []
  //   } catch (error) {
  //     if (error && typeof error === 'object' && 'message' in error) {
  //       showToastNotification('danger', (error as IApiErrorResponse).message);
  //     } else {
  //       showToastNotification('danger', 'Something went wrong');
  //     }
  //     return []
  //   }

  // };

  return (
    <Modal
      className="modal-dialog modal-dialog-centered modal-md"
      isOpen={isOpen}
    >
      <div className="modal-content shadow-lg">
        <div className="modal-header p-4">
          <h1
            className="modal-title fs-3 rajdhani-semibold"
            id="addHolidayModalLabel"
          >
            {editData ? 'Edit' : 'Add'} Asset Request
          </h1>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              clearErrors();
              onClose();
              reset();
            }}
          />
        </div>
        <div className="modal-body p-4">
          <form onSubmit={handleSubmit(onSubmit)}>
            <CardLayout cardStyle="shadow-none mb-0">
              <div className="row">
                <FieldLayout>
                  <Label required={true} id="assetCategoryId">
                    Asset Category
                  </Label>
                  <Controller
                    control={control}
                    name="assetCategoryId"
                    rules={errorTypes.required()}
                    render={({ field }) => (
                      <SearchSelectBox
                        value={field.value}
                        title="Select Asset Category"
                        onChange={(option) =>
                          field.onChange(option?.value || '')
                        }
                        isAsync
                        fetchOptions={getAssetsCategory}
                        defaultFetch
                        disable={isLoading}
                        isUsingFilter
                      />
                    )}
                  />
                  <ErrorMessage message={errors?.assetCategoryId?.message} />
                </FieldLayout>
                {/* <FieldLayout>
                  <Label required={true} id="assetCategoryId">
                    Asset
                  </Label>
                  <Controller
                    control={control}
                    name="assetId"
                    disabled={!watch("assetCategoryId")}
                    rules={errorTypes.required()}
                    render={({ field }) => (
                      <SearchSelectBox
                        value={field.value}
                        title="Select Asset"
                        onChange={(option) =>
                          field.onChange(option?.value || '')
                        }
                        isAsync
                        fetchOptions={getAssets}
                        defaultFetch
                        disable={isLoading}
                        isUsingFilter
                      />
                    )}
                  />
                  <ErrorMessage message={errors?.assetCategoryId?.message} />
                </FieldLayout> */}
                <div className="col-12">
                  <div className="form-group mb-3">
                    <label htmlFor="description" className="form-label">
                      Requirements <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                      rows={3}
                      id="description"
                      placeholder="Enter Requirements here"
                      {...register('description', {
                        required: 'Requirements is required',
                      })}
                    />
                    {errors.description && (
                      <div className="form-text text-danger">
                        {errors.description.message}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </CardLayout>
            <div className="modal-footer p-2">
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  clearErrors();
                  onClose();
                  reset();
                }}
              >
                Cancel
              </button>
              <Button
                type="submit"
                className="btn btn-primary"
                isLoading={isLoading}
              >
                {editData ? 'Edit Asset Request' : 'Create Asset Request'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};
export default AddAssetRequestModal;
